<template>
  <div class="otp-enter-phone-wrapper">
    <div class="icon-wrapper">
      <mobile-phone-icon />
    </div>

    <div class="text-header-1 mb-8px">
      {{ $t('customerInfoStep.otp.verifyPhone') }}
    </div>
    <div class="text-body-4 mb-32px">
      {{ $t('customerInfoStep.otp.vehicleHistoryInfoText') }}
    </div>

    <el-input
      :placeholder="$t('customerInfoStep.otp.phonePlaceholder')"
      type="tel"
      v-model="phone"
      inputmode="tel"
      oninput="this.value = this.value.replace(/[^\d+]+/g, '').replace(/(\..*)\./g, '$1')"
    />

    <transition name="fade-faster">
      <div class="mt-12px" v-if="error">
        <el-alert class="text-left" effect="dark" :title="error" type="error" />
      </div>
    </transition>

    <el-checkbox class="terms-checkbox mt-16px" v-model="termsAccepted">
      <div class="text-body-5 text-left">
        {{ $t('customerInfoStep.otp.optInDisclaimer.email', { accountName }) }}
        <router-link :to="'/terms?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.termsAndConditions') }}
        </router-link>
        |
        <router-link :to="'/privacy?shop=' + this.accountSlug" target="_blank">
          {{ $t('general.privacyPolicy') }}
        </router-link>
      </div>
    </el-checkbox>

    <transition name="fade-faster">
      <sticked-to-bottom-button
        v-if="phone && phone.length >= 4 && ((termsAccepted && accountRequiredOptIn) || !accountRequiredOptIn)"
        :loading="loading"
        @btn-click="sendOTP"
      />
    </transition>
  </div>
</template>

<script>
import MobilePhoneIcon from './MobilePhoneIcon';
import StickedToBottomButton from '@/components/global/StickedToBottomButton';

import OTPService from '@/services/OTPService';

export default {
  name: 'EnterCustomerPhoneForEmailOtp',
  components: {
    MobilePhoneIcon,
    StickedToBottomButton,
  },
  props: {
    accountSlug: {
      type: String,
      required: true,
    },
    accountName: {
      type: String,
      required: true,
    },
    accountOtpSetting: {
      type: String,
      required: true,
    },
    accountRequiredOptIn: {
      type: Boolean,
      required: true,
    },
    actionButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phone: '',
      email: '',
      loading: false,
      error: '',
      termsAccepted: false,
    };
  },
  methods: {
    async sendOTP() {
      if (this.actionButtonDisabled) return;

      if (this.error) this.error = '';

      try {
        this.loading = true;
        let data, response;
        if (this.accountOtpSetting === 'sms') {
          response = await OTPService.post.sendOTP(this.accountSlug, this.phone);
        } else {
          response = await OTPService.post.sendEmailOTP(this.accountSlug, this.phone);
        }
        data = response.data || {};

        this.loading = false;
        this.$posthog.capture('addPhoneNumber_*_otpSent');
        this.$emit('otp-sent', {
          phone: this.phone,
          email: data.email || '',
          otpSent: data.otp_sent,
          termsAccepted: this.termsAccepted,
        });
        this.$emit('set-customer-blocked-from-booking', {
          blockedFromBooking: data.customer_blocked_from_booking || false,
        });
        // Enable abandonment timer
        this.$emit('start-abandonment-timer', { phone: this.phone, email: this.email });
      } catch (error) {
        this.loading = false;
        this.error = error.response.data.message || '';
        this.$posthog.capture('addPhoneNumber_*_otpSentFailed', {
          errorMessage: this.error,
        });
      }
    },
  },
};
</script>

<style></style>
